import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Wordmark from "@/components/Wordmark";

export default function LegalLayout({ title, lastUpdated, children, testid }) {
  return (
    <div
      className="min-h-screen w-full bg-[#FAF9F7] text-[#2C2A29]"
      data-testid={testid}
    >
      <header className="px-6 sm:px-12 pt-8 pb-4 flex items-center justify-between max-w-4xl mx-auto">
        <Link
          to="/"
          className="font-serif tracking-tight select-none"
          data-testid="legal-home-link"
        >
          <Wordmark size="md" testid="legal-home-wordmark" />
        </Link>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md font-sans text-sm text-[#2C2A29] hover:bg-[#EFEAE0] transition-colors"
        >
          <ArrowLeft size={14} strokeWidth={2} />
          Back to home
        </Link>
      </header>

      <main className="px-6 sm:px-12 pb-20 pt-6 max-w-4xl mx-auto">
        <p className="font-sans text-[10px] uppercase tracking-[0.24em] text-[#7A7571] font-semibold mb-3">
          Legal
        </p>
        <h1
          className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] mb-3"
          data-testid="legal-title"
        >
          {title}
        </h1>
        {lastUpdated ? (
          <p className="font-sans text-xs text-[#A5A29E] mb-10">
            Last updated: {lastUpdated}
          </p>
        ) : null}

        <div className="legal-prose font-sans text-[15px] leading-[1.75] text-[#3a3735]">
          {children}
        </div>
      </main>

      <footer className="px-6 sm:px-12 py-6 border-t border-[#EFEAE0] flex items-center justify-between flex-wrap gap-2 max-w-4xl mx-auto">
        <p className="font-sans text-xs text-[#A5A29E]">
          ©{" "}
          <Wordmark
            size="sm"
            inkClassName="text-[#A5A29E]"
            testid="legal-footer-wordmark"
            className="text-xs"
          />
        </p>
        <div className="flex items-center gap-4">
          <Link
            to="/legal/terms"
            className="font-sans text-xs text-[#7A7571] hover:text-[#2C2A29] transition-colors"
            data-testid="legal-footer-terms-link"
          >
            Terms of Service
          </Link>
          <Link
            to="/legal/privacy"
            className="font-sans text-xs text-[#7A7571] hover:text-[#2C2A29] transition-colors"
            data-testid="legal-footer-privacy-link"
          >
            Privacy Policy
          </Link>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ heading, children, testid }) {
  return (
    <section className="mb-10" data-testid={testid}>
      <h2 className="font-serif text-2xl tracking-tight text-[#2C2A29] mb-3 mt-2">
        {heading}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
